import Address from './Address';
import BaseModel from './BaseModel';
import Purchase from './Purchase';
import * as AT from '../../components/container/attributes';
import { required } from '@vuelidate/validators';
import { HitOnlineEnums } from 'hit-online-web-ui/src/helpers/constants';
import { translate } from '../../plugins/i18n/i18n';

export default class PurchaseSupplier extends BaseModel {
  constructor({
    id,
    number,
    purchase = undefined,
    supplier = undefined,
    status = undefined,
    sentDate = undefined,
    expectedResponseDate = undefined,
    responseDate = undefined,
    conform = undefined,
    exclude = undefined,
    comment = undefined,
  }) {
    super(id, number, '');
    this.purchase = purchase ? new Purchase(purchase) : null;
    this.supplier = supplier ? new Address(supplier) : null;
    this.status = status
      ? HitOnlineEnums.getEnumValue('RESPONSE_STATUS', status, translate)
      : null;
    this.sentDate = sentDate;
    this.expectedResponseDate = expectedResponseDate;
    this.responseDate = responseDate;
    this.conform = conform;
    this.exclude = exclude;
    this.comment = comment;
  }

  static get fkName() {
    return null;
  }
  static get apiRoute() {
    return 'purchase_supplier';
  }
  static get detailPageRoute() {
    return undefined;
  }
  static get listPageRoute() {
    return undefined;
  }
  get fkName() {
    return PurchaseSupplier.fkName;
  }
  get apiRoute() {
    return PurchaseSupplier.apiRoute;
  }
  get detailPageRoute() {
    return PurchaseSupplier.detailPageRoute;
  }
  get listPageRoute() {
    return PurchaseSupplier.listPageRoute;
  }

  static get entityListDisplayAttrs() {
    return this.getAttributes(
      [
        'number',
        'supplier',
        'totalAmount',
        'status',
        'sentDate',
        'expectedResponseDate',
        'responseDate',
        'conform',
        'exclude',
        'comment',
      ],
      ['sortOrder'],
    );
  }

  static get allAttributes() {
    return [
      new AT.StringAttribute({
        name: 'number',
        column: 'no',
        // Hide number column in purchase suppliers panel , discussion with Ralph
        // tableProperties: {
        //   header: 'hit-app.common.number',
        //   maxWidth: '0.75fr',
        // },
      }),
      new AT.FkPurchaseAttribute({
        name: 'purchase',
        joinPath: ['purchase!fk_purchase_supplier_purchase_id_purchase'],
        tableProperties: {
          header: 'hit-base.common.purchase',
        },
      }),
      new AT.FkAddressAttribute({
        name: 'supplier',
        validations: { required },
        joinPath: ['address!fk_purchase_supplier_supplier_id_address'],
        fkToUpdate: 'supplier_id',
        supplementaryJoinColumns: ['communicationModeData'],
        tableProperties: {
          header: 'hit-app.common.supplier',
        },
      }),
      new AT.NotFetchedAttribute({
        name: 'totalAmount',
        readOnly: true,
        tableProperties: {
          header: 'hit-app.common.amount',
          minWidth: '8rem',
          maxWidth: '11rem',
          readOnly: true,
        },
        forcedType: 'decimal',
      }),
      new AT.EnumerationAttribute({
        name: 'status',
        enumType: 'RESPONSE_STATUS',
        enumClass: HitOnlineEnums,
        column: 'status',
        creationValue: HitOnlineEnums.getEnumValue(
          'RESPONSE_STATUS',
          'IN_PROGRESS',
          translate,
        ),
        tableProperties: {
          header: 'hit-app.common.status',
          minWidth: '10rem',
          maxWidth: '14rem',
        },
      }),
      new AT.DateAttribute({
        name: 'sentDate',
        column: 'sent_date',
        tableProperties: {
          header: 'hit-app.purchase.sent-date',
          minWidth: '8rem',
          maxWidth: '10rem',
        },
      }),
      new AT.DateAttribute({
        name: 'expectedResponseDate',
        column: 'expected_response_date',
        creationValue: false,
        tableProperties: {
          header: 'hit-app.purchase.expected-response-date',
          //        maxWidth: '1fr',
          onlyShowInEdition: true,
        },
      }),
      new AT.DateAttribute({
        name: 'responseDate',
        column: 'response_date',
        creationValue: false,
        tableProperties: {
          header: 'hit-app.purchase.response-date',
          //   maxWidth: '0.75fr',
          onlyShowInEdition: true,
        },
      }),
      new AT.BooleanAttribute({
        name: 'conform',
        column: 'conform',
        tableProperties: {
          header: 'hit-app.purchase.conform',
          // maxWidth: '0.5fr',
          onlyShowInEdition: true,
        },
      }),
      new AT.BooleanAttribute({
        name: 'exclude',
        column: 'exclude',
        tableProperties: {
          header: 'hit-app.purchase.exclude',
       //   maxWidth: '0.5fr',
          onlyShowInEdition: true,
        },
      }),
      new AT.StringAttribute({
        name: 'comment',
        column: 'comment',
        tableProperties: {
          header: 'hit-app.common.comment',
          minWidth: '12rem',
          maxWidth: '2fr',
        },
      }),
      new AT.IntegerAttribute({
        name: 'sortOrder',
        column: 'sort_order',
        readOnly: true,
      }),
    ];
  }
}
